import { Phone, MessageCircle } from "lucide-react";
import { PHONE_TEL, WHATSAPP_URL } from "@/constants/site";
import { useLanguage } from "@/i18n/LanguageContext";

export const FloatingButtons = () => {
  const { t } = useLanguage();

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3" data-testid="floating-contact-buttons">
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t.aria.whatsapp}
        data-testid="floating-whatsapp-button"
        className="flex items-center justify-center h-14 w-14 rounded-full bg-[#D4AF37] text-[#1A1412] shadow-[0_8px_32px_rgba(201,162,39,0.35)] hover:bg-[#E5C15D] hover:scale-105 transition-all duration-300"
      >
        <MessageCircle className="h-6 w-6" />
      </a>
      <a
        href={PHONE_TEL}
        aria-label={t.aria.call}
        data-testid="floating-call-button"
        className="flex items-center justify-center h-14 w-14 rounded-full border border-[#D4AF37]/60 bg-[#1A1412]/90 backdrop-blur text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#1A1412] hover:scale-105 transition-all duration-300"
      >
        <Phone className="h-6 w-6" />
      </a>
    </div>
  );
};
